import _ from 'underscore';
import { useEffect } from 'react';
import { useCreatePromise } from './use-create-promise';

export const useCreateHookResultPromise = <TResult = unknown>({
  result,
  error,
}: {
  result?: TResult;
  error?: unknown;
}) => {
  const [{
    lastCreatedPromise,
  }, {
    createPromise,
    resolveLastCreatedPromise,
    rejectLastCreatedPromise,
  }] = useCreatePromise<TResult>();

  useEffect(() => {
    if (result && _.isFunction(lastCreatedPromise.then)) {
      resolveLastCreatedPromise(result);
    }
  }, [lastCreatedPromise, resolveLastCreatedPromise, result]);

  useEffect(() => {
    if (error && _.isFunction(lastCreatedPromise.catch)) {
      rejectLastCreatedPromise(error);
    }
  }, [error, lastCreatedPromise, rejectLastCreatedPromise]);

  return createPromise;
};
